var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    _vm._b(
      { staticClass: "max-height elevation-1" },
      "v-card",
      _vm.$attrs,
      false
    ),
    [
      _c("v-card-text", { staticClass: "card-bg-1" }, [
        _c("div", { staticClass: "caption grey--text text--darken-2" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "headline" },
          [
            _vm._t("default", function () {
              return [_vm._v("\n        " + _vm._s(_vm.text) + "\n      ")]
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }